import { List, Map, Record } from 'immutable'

import { USA_CODE, USA_ISO } from 'app/constants/phoneCountryCodes'

export const OrganizationSettingsRecord = Record({
  id: null,
  name: null,
  domain: null,
  logo: null,
  totalUsers: null,
  welcomeEmail: Map(),
})

export class OrganizationSettings extends OrganizationSettingsRecord {}

export class CountriesCodesForSelect extends Record({
  country: USA_ISO,
  code: USA_CODE,
}) {}

export class PromoPage extends Record({
  phoneIsRequired: false,
  isPromoPageActive: false,
  image: undefined,
  title: undefined,
  title_v2: undefined,
  subTitle: undefined,
  subTitle_v2: undefined,
  pageType: undefined,
  formTitle: undefined,
  formTitle_v2: undefined,
  formSubTitle: undefined,
  formSubTitle_v2: undefined,
  welcomeText_v2: undefined,
  quote_v2: undefined,
  quoteAuthor_v2: undefined,
  quoteAuthorAbout_v2: undefined,
  secondTitle_v2: undefined,
  secondSubTitle_v2: undefined,
  textBoxesHeader_v2: undefined,
  firstBoxTitle_v2: undefined,
  firstBoxSubTitle_v2: undefined,
  secondBoxTitle_v2: undefined,
  secondBoxSubTitle_v2: undefined,
  thirdBoxTitle_v2: undefined,
  thirdBoxSubTitle_v2: undefined,
  fourthBoxTitle_v2: undefined,
  fourthBoxSubTitle_v2: undefined,
  mainBackground_v2: undefined,
  proQuoteAuthorImage_v2: undefined,
  platformAboutImage_v2: undefined,
  firstBoxImage_v2: undefined,
  secondBoxImage_v2: undefined,
  thirdBoxImage_v2: undefined,
  fourthBoxImage_v2: undefined,
}) {}

export class OrganizationSettingsByDomain extends Record({
  sms: false,
  promoPageSettings: new PromoPage(),
  organization: Map({
    id: null,
    name: null,
    logo: null,
  }),
  language: null,
  countriesCodes: List(),
  logo: null,
}) {}
